import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';

@Component({
  selector: 'app-popup-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './popup-message.component.html',
  styleUrl: './popup-message.component.scss'
})
export class PopupMessageComponent {
  // Driven imperatively by parents via ViewChild, so this state must be signal-based under OnPush.
  readonly message = signal<string>('');
  readonly show = signal(false);

  showMessage(newMessage: string): void {
    this.message.set(newMessage);
    this.show.set(true);
  }

  closePopup(): void {
    this.show.set(false);
  }
}
